namespace AgerLMS.Coaching {
    export interface StudyTrackingRow {
        Id?: number;
        UserId?: number;
        ExamDateId?: number;
        ExamTypes?: ExamTypes;
        TargetPointType?: LessonGroups;
        TargetPoint?: number;
        HasCurrentState?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        ExamDateExamDateName?: string;
        ExamDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace StudyTrackingRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Coaching.StudyTracking';
        export const deletePermission = 'Coaching:StudyTracking:Modify';
        export const insertPermission = 'Coaching:StudyTracking:Modify';
        export const readPermission = 'Coaching:StudyTracking:Read';
        export const updatePermission = 'Coaching:StudyTracking:Modify';

        export declare const enum Fields {
            Id = "Id",
            UserId = "UserId",
            ExamDateId = "ExamDateId",
            ExamTypes = "ExamTypes",
            TargetPointType = "TargetPointType",
            TargetPoint = "TargetPoint",
            HasCurrentState = "HasCurrentState",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            ExamDateExamDateName = "ExamDateExamDateName",
            ExamDate = "ExamDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
